import { lazy, useMemo } from "react";
import { useSelector } from "react-redux";
import { skipToken } from "@reduxjs/toolkit/dist/query";

import { selectCurrentAccount, useGetInvitationsQuery } from "fond/api";
import { RoutedTabs, TabDefinition } from "fond/widgets/RoutedTabs";

import { UserManagementTabContent } from "../common.styles";
import { TabBadge } from "./PendingInvites/PendingInvites.styles";

const UserListTab = lazy(() => import("./UserList/UserList"));
const PendingInvitesTab = lazy(() => import("./PendingInvites/PendingInvites"));

const UserManagement: React.FC = () => {
  const selectedAccount = useSelector(selectCurrentAccount);
  const { data: pendingInvites } = useGetInvitationsQuery(selectedAccount?.ID ?? skipToken);

  const tabs = useMemo(
    (): TabDefinition[] => [
      { label: "User List", path: "list", component: UserListTab, event: "settings.users.userlist.viewed" },
      {
        label: <TabBadge badgeContent={pendingInvites?.length}>Pending Invites</TabBadge>,
        path: "pending-invites",
        component: PendingInvitesTab,
        event: "settings.users.invites.viewed",
      },
    ],
    [pendingInvites?.length]
  );

  return <RoutedTabs ContentContainer={UserManagementTabContent} prefix="/settings/users" tabs={tabs} data-testid="user-management" />;
};

export default UserManagement;
